import type { AlignmentProperty } from '../../../documentManagement/Breadcrumbs.schemaTypes';
import type { LogicalAlignment } from '@wix/editor-elements-common-utils';

const flexToLogicalAlignmentMap: Record<
  AlignmentProperty | LogicalAlignment,
  LogicalAlignment
> = {
  'flex-start': 'start',
  'flex-end': 'end',
  center: 'center',
  start: 'start',
  end: 'end',
};

export const flexToLogicalAlignment = (alignment: string) =>
  flexToLogicalAlignmentMap[alignment as AlignmentProperty | LogicalAlignment];
